module.exports = "\r\n.background {\r\n  background-color: rgb(6, 38, 80)\r\n}\r\n\r\n.i-box {\r\n  width: 60px;\r\n}\r\n\r\n.in-line {\r\n  display: inline;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/advanced-bol/advanced-bol.component.css
// module id = ./src/app/advanced-bol/advanced-bol.component.css
// module chunks = main